import {BasePanelPage} from "../panels/BasePanelPage.jsx";

export class ShopOrderSuccessPanel extends BasePanelPage {
    render() {
        return "OK!";
    }
}